<template>
<nav>
    <ul class="pagination">
        <li v-bind:class="{ 'disabled': links.previous === undefined }">
            <a href="#" aria-label="Previous" @click.prevent="prevPage()">
                <span aria-hidden="true">&laquo;</span>
            </a>
        </li>
        <li v-for="page in pagesWindow" v-bind:class="{ 'active': pagination.current_page === page }"><a href="#" @click.prevent="setPage(page)">{{ page }}</a></li>
        <li v-bind:class="{ 'disabled': links.next === undefined }">
            <a href="#" aria-label="Next" @click.prevent="nextPage()">
                <span aria-hidden="true">&raquo;</span>
            </a>
        </li>
    </ul>
</nav>
</template>

<script type="text/javascript">
    export default {
        props: ['resource', 'pagination', 'history', 'api-v2', 'params'],

        data: function() {
            return {
                'v2': this.apiV2 || false
            };
        },

        computed: {
            pages: function () {
                let pages = [];

                for (let i = 0; i < this.pagination.total_pages; i++) {
                    pages.push(i + 1);
                }

                return pages;
            },
            pagesWindow: function () {
                if (this.pages.length <11) {
                    return this.pages;
                }

                let start = 0;
                let end = 10;

                if (this.pagination.total_pages > 10 && this.pagination.current_page > 4 && this.pagination.current_page < (this.pagination.total_pages-5)) {
                    start = this.pagination.current_page - 5;
                    end = this.pagination.current_page + 5;
                } else if ( this.pagination.total_pages > 10 && this.pagination.current_page >= (this.pagination.total_pages-5)) {
                    start = this.pagination.total_pages - 10;
                    end = this.pagination.total_pages;
                }

                let pages = [];

                for (let i = start; i < end; i++) {
                    pages.push(i + 1);
                }

                return pages;
            },
            links: function () {
                return this.pagination.links || {};
            }
        },

        methods: {
            nextPage: function () {
                if(this.pagination.links.next === undefined ) {
                    return false;
                }
                this.link = this.pagination.links.next;
                this.setHistory();
                this.getData();
            },

            prevPage: function () {
                if(this.pagination.links.previous === undefined ) {
                    return false;
                }
                this.link = this.pagination.links.previous;
                this.setHistory();
                this.getData();
            },

            setPage: function (page) {
                var url = this.pagination.links.next || this.pagination.links.previous;
                if(url !== undefined){
                    this.link = url.replace(/page=\d+/, 'page=' + page);
                    this.getData();
                }
            },

            getData: function () {
                this.$emit('startUpdatePage');
                let options = {'headers': {}};
                if(this.v2) {
                    options.headers['Accept'] = 'application/x.onemb.v2+json';
                }
                if(this.params) {
                    options.params = this.params;
                }
                this.$http.get(this.link, options).then(function (response) {
                    this.$emit('updateResource', response.data.data);
                    this.$emit('updatePage', response.data.meta.pagination);
                    this.setHistory();
                }).catch(error => {});
            },

            setHistory: function () {
                if (!this.history) {
                    return;
                }
                var self = this;
                var obj = {resource: self.resource, pagination: self.pagination};
                var title = "Page" + self.pagination.current_page;
                var url = self.pagination.current_page;
                history.pushState(obj, title, url);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pagination.vue